// extracted by mini-css-extract-plugin
export default {"navUl":"Navbar_navUl__R5LCg","navLi":"Navbar_navLi__BtP4W"};